import { lazy } from 'react';

const CustomerAging = lazy(() => import('../pages/Customers/CustomerAging'));
const CustomerAgingReport2 = lazy(() =>
  import('../pages/CustomerAgingReport2'),
);

const customerAgingRoute = {
  public: [],
  auth: [
    {
      name: 'customer_aging',
      path: '/credit-and-collections/management/customer-aging',
      component: CustomerAging,
    },
    {
      name: 'customer_aging_2',
      path: '/credit-and-collections/management/customer-aging-2',
      component: CustomerAgingReport2,
    },
  ],
};

export default customerAgingRoute;
